import QuantityPicker from '@common/components/QuantityPicker';
import {
  ButtonWrapper,
  PerStayWrapper,
} from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/PerStay/PerStay.styles';
import { useTranslations } from '@lang';
import { FieldPath, useFormContext, useWatch } from 'react-hook-form';
import { MultiRoomSearch } from 'shared-types';
import { RoomRateFormValues } from '../../../RoomRateFormV2.schema';

const extrasField = (roomKey: string, id: number, field: string) =>
  `extras.${roomKey}.${id}.${field}` as FieldPath<RoomRateFormValues>;

type MultiRoomPerStayV2Props = {
  id: number;
  maxQuantity: number | null;
  pricingType: string | null;
  rooms: MultiRoomSearch;
};

export const MultiRoomPerStayV2 = ({
  id,
  maxQuantity,
  pricingType,
  rooms,
}: MultiRoomPerStayV2Props) => {
  const { t } = useTranslations();
  const { setValue } = useFormContext<RoomRateFormValues>();
  const guestValues = useWatch({ name: 'guests' }) ?? [];
  const extrasValues = (useWatch({ name: 'extras' }) ?? {}) as Record<
    string,
    { isSelected?: boolean; quantity?: number }[]
  >;

  return (
    <PerStayWrapper>
      {(rooms ?? []).map((_, i) => {
        const roomKey = `room-${i}`;
        const currentQuantity = extrasValues?.[roomKey]?.[id]?.quantity ?? 0;
        const guestsInRoom = (guestValues as RoomRateFormValues['guests']).filter(
          (g) => g.room === i + 1
        );
        const effectiveMaxQuantity =
          pricingType === 'per_stay' ? 1 : guestsInRoom.length || maxQuantity;

        return (
          <ButtonWrapper key={i}>
            <div>{`${t('common.room')} ${i + 1}`}</div>
            <QuantityPicker
              input={{
                value: currentQuantity,
                onChange: (newQty: number) => {
                  setValue(extrasField(roomKey, id, 'isSelected'), newQty > 0);
                  setValue(extrasField(roomKey, id, 'quantity'), newQty);
                },
              }}
              maxValue={effectiveMaxQuantity ?? undefined}
              minValue={0}
              showZeroCounter
            />
          </ButtonWrapper>
        );
      })}
    </PerStayWrapper>
  );
};
